import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "backoffice-layout" }
const _hoisted_2 = { class: "navbar-dark bg-primary" }
const _hoisted_3 = { class: "container content-space-1 content-space-b-lg-3" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "pt-4"
}
const _hoisted_6 = {
  key: 0,
  class: "text-white"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "text-white bi-eye me-1" }, null, -1)
const _hoisted_8 = { class: "backoffice-layout-content container content-space-1 content-space-t-lg-0 content-space-b-lg-2 mt-lg-n10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitBreadcrumb = _resolveComponent("MrUiKitBreadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.layoutConfig.hideBreadcrumb || _ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.currentBreadcrumb)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.currentBreadcrumb.label), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_MrUiKitBreadcrumb, {
                  mode: "white",
                  items: _ctx.items,
                  onNavigate: _ctx.onNavigateBreadcrumb
                }, null, 8, ["items", "onNavigate"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.layoutConfig.hideSwitch)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToFrontend && _ctx.goToFrontend(...args))),
                class: "ms-auto text-white pointer-sub mb-2 align-items-md-center"
              }, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.t('common.operations.preview')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}